export function deicticReasonSentence(reason: string): string {
  const reasons: Record<string, string> = {
    deictic_target_missing: 'The document to check could not be found.',
    deictic_unknown_document_shape: 'The document has an unexpected structure, so its learner text could not be checked.',
    deictic_invalid_learner_field: 'A learner text field is invalid, or a step has no text.',
    deictic_unknown_wiring_shape: 'The answer options have an unexpected structure, so their visible text could not be checked.',
    deictic_projection_failed: 'This correction could not be applied to the document used for the check.',
    deictic_case_unresolved: 'The case groups linked to this question could not be followed to their case text.',
    deictic_case_ambiguous: 'This question belongs to two case groups with different case text, so the case it is read with is unclear.',
    deictic_case_invalid_text: 'A case group linked to this question has invalid case text.',
    deictic_case_invalid_membership: 'A case group linked to this question has an invalid question link.',
    deictic_report_too_large: 'The reference check has too much evidence to save.',
    deictic_store_unavailable: 'The content store was unavailable when the reference check was attempted.',
    deictic_content_reader_unavailable: 'The content reader was unavailable when the reference check was attempted.',
  };
  return reasons[reason] ?? 'The reference check could not be completed.';
}
